// Presentation-only bank-line state shared by the month-control surface.
// Loaded before the lazy month-control and bank page scripts.
const PLUMME_HANDLED_BANK_LINE_STATUSES = new Set(['godkjent', 'matchet', 'bokfort', 'privat', 'korrigert']);
const PLUMME_REOPEN_BANK_LINE_NOTICES = new Set([
  'Banklinjen er åpnet igjen. Kontroller og godkjenn på nytt for å bokføre.',
  'Koblingen til den eksisterende posten er åpnet igjen. Kontroller banklinjen på nytt.',
]);

const apMonthControlVisibleLineSub = (line) => {
  const sub = String(line?.sub || '');
  const raw = line?._backend || {};
  const handled = Boolean(raw.matchedEntryId) || (!(line?.status === 'avvik' || raw.reconciliationStatus === 'manual-review' || raw.source === 'manual')
    && PLUMME_HANDLED_BANK_LINE_STATUSES.has(String(line?.status || '')));
  return handled && PLUMME_REOPEN_BANK_LINE_NOTICES.has(sub.trim()) ? '' : sub;
};

const bankLineWasAlreadyBookedBeforeReconciliation = (line) => {
  const raw = line?._backend || line || {};
  return Boolean(raw.matchedEntryId) && raw.bookingType === 'existing-entry';
};

const bankLineCanUseReceiptDuplicateMatch = (line) => {
  const raw = line?._backend || line || {};
  return !raw.matchedEntryId;
};

Object.assign(window, {
  apMonthControlVisibleLineSub,
  bankLineWasAlreadyBookedBeforeReconciliation,
  bankLineCanUseReceiptDuplicateMatch,
});
